import { Controller, FieldPath, useFormContext, useWatch } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormDescription, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { NumberInput } from '@fortem-monorepo/react-ui'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'
import { getNumberTypeSuffix } from '@/utilities/format'

export const ThresholdsField: React.FC = () => {
  const { control } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="thresholds"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Thresholds</FormLabel>
              <FormError />
            </div>
            <FormDescription>
              The threshold values the value columns should stay between.
            </FormDescription>
            <table>
              <thead>
                <th className={'font-medium text-xs text-left text-gray-600'}>Hard Lower</th>
                <th className={'font-medium text-xs text-left text-gray-600'}>Soft Lower</th>
                <th className={'font-medium text-xs text-left text-gray-600'}>Soft Upper</th>
                <th className={'font-medium text-xs text-left text-gray-600'}>Hard Upper</th>
              </thead>
              <tbody>
                <tr>
                  <td className={'px-1 py-1'}>
                    <ThresholdNumberInput name={'thresholds.hard_lower'} />
                  </td>
                  <td className={'pl-1 py-1'}>
                    <ThresholdNumberInput name={'thresholds.soft_lower'} />
                  </td>

                  <td className={'px-1 py-1'}>
                    <ThresholdNumberInput name={'thresholds.soft_upper'} />
                  </td>
                  <td className={'pr-1 py-1'}>
                    <ThresholdNumberInput name={'thresholds.hard_upper'} />
                  </td>
                </tr>
              </tbody>
            </table>
          </FormItem>
        )
      }}
    />
  )
}

type ThresholdNumberInputProps = {
  name: FieldPath<GuidelineFormValues>
}

const ThresholdNumberInput: React.FC<ThresholdNumberInputProps> = ({ name }) => {
  const { control, trigger } = useFormContext<GuidelineFormValues>()
  const thresholdType = useWatch({ control, name: 'threshold_type' })

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <NumberInput
            name={field.name}
            value={typeof field.value === 'number' ? field.value : null}
            thousandSeparator={','}
            suffix={getNumberTypeSuffix(thresholdType)}
            onBlur={field.onBlur}
            onValueChange={(values) => {
              const nextValue = values.floatValue
              field.onChange(typeof nextValue === 'number' ? nextValue : null)
              trigger('thresholds')
            }}
          />
        )
      }}
    />
  )
}
